import { Box, Typography } from '@mui/material'
import { Trans } from '@lingui/macro'
import { TemplatesViewer } from './TemplatesViewer'
import { ReportTemplate } from '@/core/models/report.model'

interface TemplatesTabContentProps {
  isLoading: boolean
  error: unknown
  templates: ReportTemplate[] | undefined
}

export function TemplatesTabContent({ isLoading, error, templates }: TemplatesTabContentProps) {
  if (isLoading) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1">
          <Trans>Loading templates...</Trans>
        </Typography>
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="error">
          <Trans>Error loading templates. Please try again.</Trans>
        </Typography>
      </Box>
    )
  }

  if (!templates) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1">
          <Trans>No templates available</Trans>
        </Typography>
      </Box>
    )
  }

  return <TemplatesViewer templates={templates} />
}

